<template>
    <div>
        <el-table-grid
            class="item-table"
            ref="table"
            :data="list"
            border
            :max-height="height"
            tooltip-effect="dark"
            :stripe="false"
            @selection-change="handleSelectionChange"
            @sort-change="handleSort"
            :class="[`row-cell-height${rowHeight}`]"
            :row-key="rowKey ? (row) => {
                return row[rowKey]
            } : null"
            :row-style="rowStyle"
            @header-dragend="headerDragend"
        >
            <el-table-column v-if="selection" align="center" :reserve-selection="!!rowKey" type="selection" width="55" fixed="left"></el-table-column>
            <el-table-column
                align="center"
                width="50"
                type="index"
                :index="indexMethod">
            </el-table-column>
            <el-table-column
                v-for="(col, cindex) in mergeCols"
                :key="col.prop + cindex"
                :prop="col.prop"
                :resizable="resizable"
                v-bind="col.attrs"
                width="auto"
                :min-width="col.attrs.width">
                <template slot="header">
                    <template v-if="col.headerSlot">
                        <slot :name="col.prop + 'HeaderSlot'" v-bind="{col}"></slot>
                    </template>
                    <template v-else>
                        {{ col.attrs.label }}
                    </template>
                </template>
                <template slot-scope="scope">
                    <slot v-if="col.slot" :name="col.prop + 'Slot'" v-bind="scope"></slot>
                    <template v-else>{{ scope.row[col.prop] }}</template>
                </template>
            </el-table-column>
            <!-- 操作列 -->
            <el-table-column
                v-if="opConfig"
                :resizable="false"
                v-bind="opConfig.attrs">
                <template slot-scope="scope">
                    <slot v-if="opConfig.slot" :name="opConfig.prop + 'Slot'" v-bind="scope"></slot>
                    <template v-else>{{ scope.row[opConfig.prop] }}</template>
                </template>
            </el-table-column>
            <template slot="empty">
                <span>暂无数据</span>
                <!-- 初始化功能再议，先注释 -->
                <!-- <el-button type="link" v-if="isFirstImport" @click="syncDistriItem">同步ERP可分销商品</el-button> -->
            </template>
        </el-table-grid>
        <DownloadProgress ref="distritem_progressDialog" :percentage.sync="percentage" >
            <template slot="title">
                <span class="down-title">	商品导入中...</span>
            </template>
        </DownloadProgress>
        <DownloadResult :resultData.sync="resultData" 
            :visible.sync="resultVisible"
            @search="search">
            <template slot="title">
                <span class="down-title">商品导入完成</span>
            </template>
        </DownloadResult>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import TableList from "../TableList.vue";
import {autoImportErpItems} from '@/api/prod/center/index';
import { getListErpItem } from '@/api/prod/center';
import { mapGetters } from "vuex";
import DownloadProgress from '@/components/prod/center/components/DownloadProgress.vue';
import DownloadResult from '@/components/prod/center/components/DownloadResult.vue';
export default {
    extends: TableList,
    props: {
        pageId: {
            type: [String, Number],
            default: ''
        },
        opConfig: Object,
        resizable: {
            type: Boolean,
            default: false
        },
    },
    components: {
		DownloadProgress,
		DownloadResult
	},
    data(){
        return {
            resultVisible: false,
            percentage: 0,
            shopResultData: {
				successNum: 0,
				totalNum: 0,
				joinDistributorLogResult: {}
			}, 
            resultData: {
				successNum: 0,
				totalNum: 0,
				joinDistributorLogResult: {}
			},
            isSupplier:false, // 供销商true, 分销商false
            // isFirstImport: false, // 首次导入true，非首次false
        }
    },
    mounted(){
        // 获取供销商还是分销商版本
        let userInfo = this.$store.getters.userInfo;
        this.isSupplier = userInfo.loginIdentity === 1 ? true : false;
        // 获取是否有导入的商品，若有，则非首次导入
        // getListErpItem({ importStatus:"1" }).then(res=> {
        //    let total = res.data?.total || 0;
        //    if(total === 0){
        //        this.isFirstImport = true;
        //    }
        // })
    },
    computed: {
        isColsConfig() {
            return !!this.pageId
        },
        ...mapGetters(['tableColsConfig']),
        mergeCols() {
            // 所有配置
            const cols = this.cols;

            // 最终的列表项
            if (this.isColsConfig) {
                const colsConfig = this.tableColsConfig(this.pageId);
                if (!colsConfig) return [];
                return colsConfig
                    .filter(({visible}) => visible) // 过滤掉不要展示的列
                    .reduce((mergeCols, config) => {
                        const col = cols.find(c => config.field === c.prop)
                        if (col) {
                            let mcol = {
                                ...col
                            }
                            mcol.attrs.width = `${config.width}px`;
                            mcol.attrs.label = config.title;
                            mergeCols.push(mcol)
                        }
                        return mergeCols;
                    }, [])
            } else {
                return cols
            }
        }
    },
    watch: {
        mergeCols() {
            this.$nextTick(() => {
                this.$refs.table.doLayout()
            })
        }
    },
    methods: {
        ...mapActions(['updateTableColsWidthByDrag']),
        indexMethod(index) {
            return (this.pagination.pageNo - 1) * (this.pagination.pageSize) + index + 1
        },
        syncDistriItem(){
            autoImportErpItems().then(res=> {
                if(res.result == 1) {
                    // 轮询结果
                    this.$refs.distritem_progressDialog.showDialog()
                    this.$refs.distritem_progressDialog.calculation_progress()
                    this.$refs.distritem_progressDialog.queryScmJobResult('IMPORT_ERP_ITEM_RULE', (res) => {
                        if(res.finished) {
                            this.resultData = {...res.result}
                            this.resultVisible = true;
                        }
                    })
                }else{
                    this.percentage = 100;
                    this.$refs.distritem_progressDialog.handleClose();
                }
            }).catch(err=> {
                this.percentage = 100;
                this.$refs.distritem_progressDialog.handleClose();
                this.percentage = 0;
            })
        },
        search(){
           this.$router.go(0);
        },
        handleSort(value){
            this.$emit('sort-change', value);
        },
        headerDragend(newWidth, oldWidth, column) {
            const col = {
                field: column.property,
                width: parseInt(newWidth),
            };
            this.updateTableColsWidthByDrag({
                pageId: this.pageId,
                col,
            });
        },
        clearSort(){
            this.$refs.table.clearSort();
        }
    }
}
</script>

<style lang="scss">
.item-table .el-button--link>span:hover:after{
    border-bottom: none !important;
}
// .el-table__body-wrapper{
//     max-height: none !important;
// }
</style>